<template>
  <div>
    <!-- 商品轮播图 -->
    <van-swipe :autoplay="3000">
      <van-swipe-item
        @click="showImagePreview(index)"
        v-for="(image, index) in images"
        :key="index"
      >
        <img class="info_img" v-lazy="https + image" />
      </van-swipe-item>
    </van-swipe>
    <!-- 商品名称及价格 -->
    <template v-for="item in shopsData">
      <div :key="item.id">
        <div class="price_box">
          <span style="color: red">￥</span>
          <span class="shops_price">{{ item.price }}</span>
        </div>
        <div class="shops_name">{{ item.title }}</div>
        <div class="shops_info">
          {{ item.synopsis }}
        </div>
      </div>
      <!-- 富文本编辑 -->
    </template>
    <!-- 修改富文本渲染部分的模板 -->
    <div
      v-for="(item, index) in shopsData"
      :key="index"
      class="rich-text-container"
      v-fix-images
      v-html="item.content"
    ></div>
    <!-- 底部占位空白（高度与 van-goods-action 一致） -->
    <div class="bottom-placeholder"></div>
    <!-- 底部立即购买 -->
      <van-goods-action>
        <!-- <van-goods-action-icon icon="chat-o" text="客服" /> -->
        <!-- <van-goods-action-icon icon="shop-o" text="收藏" /> -->
        <van-goods-action-button
          type="danger"
          text="立即购买"
          @click="onClickButton"
        />
      </van-goods-action>

    <!-- 商品规格 -->
    <van-popup
      v-model="show"
      position="bottom"
      closeable
      :style="{ height: '77%' }"
      :close-on-popstate="false"
    >
      <!-- 尺码 数量 颜色 地址 组件 -->
      <Goods
        :key="goodsKey"
        :fathMessage="shopsData"
        :goodsid="goodsid"
      ></Goods>
    </van-popup>
  </div>
</template>

<script>
import { shops_info } from "@/utils/request";
import Goods from "@/components/my_goods.vue";
import axios from "axios";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      goodsid: "",
      // 新增（只需这一个状态）
      fromAddressBack: false,
      loaded: false, // 标记是否已加载过
      images: [],
      https: "",
      shopsData: {},
      show: false,
      goodsKey: 0, // 新增组件重载标记
    };
  },
  mounted() {
    this.fetchData(); // 首次加载
  },
  methods: {
    onClickButton() {
      if (localStorage.getItem("auth_token") !== null) {
        this.show = true;
      } else {
        this.$router.push("/login");
      }
    },
    showImagePreview(index) {
      var arr = this.images.map((item) => {
        return this.https + item;
      });
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    async fetchData() {
      this.https = axios.defaults.baseURL;
      this.goodsid = this.$route.query.goods_id;
      var id = this.$route.query.goods_id;
      const res = await shops_info({
        data: {
          token: localStorage.getItem("auth_token"),
          goods_id: id,
        },
      });
      this.loaded = true;
      this.shopsData = res.data.data;
      this.images = res.data.data.info.images;

      localStorage.setItem(
        "old_address",
        JSON.stringify(res.data.data.info.address)
      );
    },
  },
  components: {
    Goods,
  },
};
</script>

<style scoped>
.info_img {
  width: 100%;
  height: 600px !important;
  object-fit: cover;
}
.price_box {
  text-align: left;
  padding: 10px 10px 0 10px;
}
.shops_price {
  color: red;
  font-weight: 700;
  font-size: 22px;
}

.shops_info {
  padding: 0 10px;
  font-size: 11px;
  color: #636161;
  text-align: left;
  line-height: 18px;
}
.shops_name {
  text-align: left;
  padding: 10px 10px;
  font-size: 18px;
}

.old_price {
  color: #a29e9e;
  font-size: 13px;
  text-decoration: line-through;
}

/* 占位元素高度 = van-goods-action 高度（默认50px） + 安全间距 */
.bottom-placeholder {
  height: 130px;
  width: 100%;
}

.rich-text-container {
  width: 100%;
  overflow-x: auto; /* 允许横向滚动 */
  word-break: break-word; /* 长文本换行 */
}

/* 修复表格样式 */
.rich-text-container ::v-deep table {
  width: 100% !important; /* 强制宽度自适应 */
  max-width: 100%; /* 限制最大宽度 */
  border-collapse: collapse;
}

.rich-text-container ::v-deep td,
.rich-text-container ::v-deep th {
  border: 1px solid #ddd;
  padding: 8px;
  white-space: nowrap; /* 防止单元格内容换行（可选） */
}
</style>